/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconFairyWand: {
  name: 'fairy_wand';
  data: string;
} = {
  name: 'fairy_wand',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m494.95 189.116 55.76-126.338-126.339 55.76-102.924-92.071 13.992 137.385-119.37 69.434 103.26 22.297c-10.147 9.291-20.781 20.039-31.733 30.99v.002L11.009 560.048v39.072h54.216l269.411-265.5c9.827-9.828 18.476-18.918 25.889-27.326l19.677 91.124 69.434-119.37 137.385 13.992-92.071-102.924z"/></svg>`,
};
